export default{
    mensajes: [],
    mensajeSelec: null,
}
